var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('page-header-new',{attrs:{"title":_vm.$t('CampaignsPage_Title_Approve')}}),_vm._v(" "),_c('page-content',[_vm._t("list",[_c('campaigns-list',{attrs:{"status":"draft"}})])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dff67a7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/campaigns/pages/ApproveCampaignsPage.vue
// module id = null
// module chunks = 